import { render, staticRenderFns } from "./BannerRecruitersLove.vue?vue&type=template&id=8389b0f6&scoped=true&"
import script from "./BannerRecruitersLove.vue?vue&type=script&lang=js&"
export * from "./BannerRecruitersLove.vue?vue&type=script&lang=js&"
import style0 from "./BannerRecruitersLove.vue?vue&type=style&index=0&id=8389b0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8389b0f6",
  null
  
)

export default component.exports